<script>
	import Icon from '$lib/Components/Layout/Icon/Icon.svelte';
	import { slide } from 'svelte/transition';

	let href = '/sales/labor-day';
	let title = 'Save 20% during our Labor Day Sale';
</script>

<div
	transition:slide
	class="full-width bg-indow-green grid w-full place-content-center py-3 text-white"
>
	<a
		{href}
		class="text-md m-0 flex w-full items-center justify-center gap-2 p-0 text-center font-medium text-balance text-white no-underline"
	>
		<span>{title}</span>
		<Icon name="arrowCircle" class="h-6 w-6" />
	</a>
</div>
